module.exports = __webpack_public_path__ + "static/media/about-2.96f6cf22.jpg";